import React from 'react';
import PillarCard from '../components/PillarCard';

const About = () => {
  const pillars = [
    {
      icon: '📚',
      title: 'Entrepreneurship Education',
      description: 'First-of-its-kind curriculum combining agricultural and biosystems engineering with entrepreneurship, co-created with growers and industry leaders.'
    },
    {
      icon: '🚀',
      title: 'Startup Support Programs',
      description: 'End-to-end support for startups including rigorous scientific and on-farm trials, product validation, mentorship, access to industry and investor networks.'
    },
    {
      icon: '💎',
      title: 'Mentorship & Ecosystem',
      description: 'Startups are guided by the Spur growers board and experts on product development, market entry, and fundraising. The Spur events connect innovators, farmers, researchers, and funders to drive ag innovation locally and globally.'
    },
    {
      icon: '👥',
      title: 'Industry Engagement',
      description: 'Strong connections with leading agricultural and food companies, fostering R&D collaboration, student internship pipeline and workforce development initiatives.'
    }
  ];

  return (
    <div className="about-page">
      <div className="container">
        <section className="about-hero">
          <h1 className="section-title">Our Innovation Ecosystem</h1>
          <p className="about-description">
            The Spur Ventures supports entrepreneurs, students, researchers, and startup founders by providing structured curriculum, startup incubation, field validation, and industry engagement under one cohesive framework. We bridge academia, industry, and growers through a strong network of internal and external partners bringing key ecosystem players together.
          </p>
        </section>

        <section className="pillars-section">
          <div className="pillars-grid">
            {pillars.map((pillar, index) => (
              <PillarCard
                key={index}
                icon={pillar.icon}
                title={pillar.title}
                description={pillar.description}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;